import jwtDecode, { JwtPayload } from "jwt-decode";
import { Token } from "../Contenedores/Autenticador/ClasesOAuth";
import { configuracionGaudi } from "../Utils/gaudiUtil";
import servicioToken from "./servicioToken";
import servicioUsuario from "./servicioUsuario";
import { FormateeIdentificacion } from "../Utils/Funciones";

export function AutenticarUsuario() {
  const parametrosAutenticacion = obtengaParametrosDeAutenticacion();
  const url = configuracionGaudi.apiAutenticador + parametrosAutenticacion;
  window.location.href = url;
}

function obtengaParametrosDeAutenticacion() {
  return (
    `client_id=${configuracionGaudi.clienteOAuth2}&` +
    `scope=openid ${configuracionGaudi.scopeCliente} offline_access&` +
    `response_type=id_token code&` +
    `redirect_uri=${configuracionGaudi.rutaRedireccionInicio}&` +
    `nonce=x&` +
    `suscriptor=${configuracionGaudi.suscriptor}`
  );
}

function obtenerCodeUrl() {
  const code = new URLSearchParams(window.location.hash).get("#code");
  return code || "";
}

function obtenerIdTokenUrl() {
  return new URLSearchParams(window.location.hash).get("id_token");
}

export function ObtengaIdentificacionEnIdToken() {
  const idtoken = obtenerIdTokenUrl();
  const decode = jwtDecode<JwtPayload>(idtoken || "");
  const identificacion = decode.sub;
  return identificacion;
}

export function cerrarSesion() {
  const url = obtengaUrlCierreSesion();
  eliminarDatosSesion();
  window.location.href = url;
}

function cerrarSesionAccesoDenegado() {
  const url = obtengaUrlCierreSesion(true);
  eliminarDatosSesion();
  window.location.href = url;
}

function obtengaUrlCierreSesion(accesoDenegado: boolean = false) {
  const token = servicioToken.obtenerToken();

  const rutaRedireccion = accesoDenegado
    ? configuracionGaudi.rutaRedireccionCerrarSesionAccesoDenegado
    : configuracionGaudi.rutaRedireccionCerrarSesion;

  const parametros =
    `id_token_hint=${token.id_token}&` +
    `post_logout_redirect_uri=${rutaRedireccion}`;

  return configuracionGaudi.apiCerrarSesion + parametros;
}

function eliminarDatosSesion() {
  servicioToken.eliminarToken();
  servicioUsuario.eliminarUsuario();
}


export async function IniciarSesion() {
  let token: Token = new Token();
  const url = configuracionGaudi.apiObtengaAccessToken;
  const data = obtengaDatosDeAutenticacion();

  await fetch(url, {
    method: "POST",
    body: data,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  })
    .then(async (res: { json: () => Token | PromiseLike<Token> }) => {
      token = await res.json();
      if (token.error) {
        window.location.href = "/cic_externo/Error/AccesoDenegadoSistema";
      } else {
        servicioToken.guardarToken(token);
        window.location.href = "/cic_externo/Inicio";
      }
    })
    .catch((error) => {
      console.log(error);
      console.error("No se pudo obtener el identificador de autenticación");
    });
}

function obtengaDatosDeAutenticacion() {
  return (
    `client_id=${configuracionGaudi.clienteOAuth2}&` +
    `code=${encodeURIComponent(obtenerCodeUrl())}&` +
    `grant_type=${encodeURIComponent("authorization_code")}&` +
    `redirect_uri=${encodeURIComponent(
      configuracionGaudi.rutaRedireccionInicio
    )}&` +
    `scope=${encodeURIComponent(
      "openid " + configuracionGaudi.scopeCliente + " offline_access"
    )}`
  );
}

export async function obtengaTokenPorRefrescamiento() {
  let token: Token = new Token();
  const url = configuracionGaudi.apiObtengaAccessToken;
  const data = obtengaDatosDeAutenticacionPorRefrescamiento();

  try {
    const respuesta = await fetch(url, {
      method: "POST",
      body: data,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });

    if (!respuesta.ok) {
      eliminarDatosSesion();
      window.location.href = "/cic_externo/Inicio";
    } else {
      token = await respuesta.json();
      servicioToken.guardarToken(token);
      return servicioToken.obtenerAccessToken();
    }
  } catch (error) {
    console.log(error);
    eliminarDatosSesion();
    window.location.href = "/cic_externo/Inicio";
  }
}

function obtengaDatosDeAutenticacionPorRefrescamiento() {
  return (
    `response_type=${encodeURIComponent("code")}&` +
    `client_id=${configuracionGaudi.clienteOAuth2}&` +
    `scope=${encodeURIComponent(
      configuracionGaudi.scopeCliente + " offline_access"
    )}&` +
    `grant_type=${encodeURIComponent("refresh_token")}&` +
    `refresh_token=${encodeURIComponent(servicioToken.obtenerRefreshToken())}`
  );
}

export function ObtengaIdentificacion() {
  const token = localStorage.getItem("token") || "";
  let parsedToken = token ? JSON.parse(token) : "";
  const accessToken = parsedToken.access_token;
  const decode = jwtDecode<JwtPayload>(accessToken || "");
  const identificacion = decode.sub;
  return FormateeIdentificacion(identificacion || "");
}

const Autenticador = {
  AutenticarUsuario,
  obtengaTokenPorRefrescamiento,
  ObtengaIdentificacionEnIdToken,
  IniciarSesion,
  cerrarSesion,
  cerrarSesionAccesoDenegado,
  ObtengaIdentificacion,
};

export default Autenticador;
